/**
 * Bill To Pax Module
 *
 * Gestisce la logica di caricamento dati per il blocco sidebar-bill-to-pax
 */

export {
  find_welfare_holder,
  find_beneficiary_by_id,
  extract_holder_form_data,
  clean_copied_fiscal_codes
} from './holder-data-loader'